import Header from './components/Header';
import About from './components/About';
import Services from './components/Services';
import FAQ from './components/FAQ';
import Calendar from './components/Calendar';
import BookingForm from './components/BookingForm';
import Footer from './components/Footer';

export default function App() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-cream to-stone-beige">
      <Header />
      <main className="max-w-4xl mx-auto px-4 py-12">
        <About />
        <Services />
        <Calendar />
        <BookingForm />
        <FAQ />
        <Footer />
      </main>
    </div>
  );
}
